[
  "fa-0",
  "fa-1",
  "fa-2",
  "fa-3",
  "fa-4",
  "fa-42-group",
  "fa-5",
  "fa-500px",
  "fa-6",
  "fa-7",
  "fa-8",
  "fa-9",
  "fa-a",
  "fa-accessible-icon",
  "fa-accusoft",
  "fa-address-book",
  "fa-address-card",
  "fa-adn",
  "fa-adversal",
  "fa-affiliatetheme",
  "fa-airbnb",
  "fa-algolia",
  "fa-align-center",
  "fa-align-justify",
  "fa-align-left",
  "fa-align-right",
  "fa-alipay",
  "fa-amazon",
  "fa-amazon-pay",
  "fa-amilia",
  "fa-anchor",
  "fa-anchor-circle-check",
  "fa-anchor-circle-exclamation",
  "fa-anchor-circle-xmark",
  "fa-anchor-lock",
  "fa-android",
  "fa-angellist",
  "fa-angle-down",
  "fa-angle-left",
  "fa-angle-right",
  "fa-angle-up",
  "fa-angles-down",
  "fa-angles-left",
  "fa-angles-right",
  "fa-angles-up",
  "fa-angrycreative",
  "fa-angular",
  "fa-ankh",
  "fa-app-store",
  "fa-app-store-ios",
  "fa-apper",
  "fa-apple",
  "fa-apple-pay",
  "fa-apple-whole",
  "fa-archway",
  "fa-arrow-down",
  "fa-arrow-down-1-9",
  "fa-arrow-down-9-1",
  "fa-arrow-down-a-z",
  "fa-arrow-down-long",
  "fa-arrow-down-short-wide",
  "fa-arrow-down-up-across-line",
  "fa-arrow-down-up-lock",
  "fa-arrow-down-wide-short",
  "fa-arrow-down-z-a",
  "fa-arrow-left",
  "fa-arrow-left-long",
  "fa-arrow-pointer",
  "fa-arrow-right",
  "fa-arrow-right-arrow-left",
  "fa-arrow-right-from-bracket",
  "fa-arrow-right-long",
  "fa-arrow-right-to-bracket",
  "fa-arrow-right-to-city",
  "fa-arrow-rotate-left",
  "fa-arrow-rotate-right",
  "fa-arrow-trend-down",
  "fa-arrow-trend-up",
  "fa-arrow-turn-down",
  "fa-arrow-turn-up",
  "fa-arrow-up",
  "fa-arrow-up-1-9",
  "fa-arrow-up-9-1",
  "fa-arrow-up-a-z",
  "fa-arrow-up-from-bracket",
  "fa-arrow-up-from-ground-water",
  "fa-arrow-up-from-water-pump",
  "fa-arrow-up-long",
  "fa-arrow-up-right-dots",
  "fa-arrow-up-right-from-square",
  "fa-arrow-up-short-wide",
  "fa-arrow-up-wide-short",
  "fa-arrow-up-z-a",
  "fa-arrows-down-to-line",
  "fa-arrows-down-to-people",
  "fa-arrows-left-right",
  "fa-arrows-left-right-to-line",
  "fa-arrows-rotate",
  "fa-arrows-spin",
  "fa-arrows-split-up-and-left",
  "fa-arrows-to-circle",
  "fa-arrows-to-dot",
  "fa-arrows-to-eye",
  "fa-arrows-turn-right",
  "fa-arrows-turn-to-dots",
  "fa-arrows-up-down",
  "fa-arrows-up-down-left-right",
  "fa-arrows-up-to-line",
  "fa-artstation",
  "fa-asterisk",
  "fa-asymmetrik",
  "fa-at",
  "fa-atlassian",
  "fa-atom",
  "fa-audible",
  "fa-audio-description",
  "fa-austral-sign",
  "fa-autoprefixer",
  "fa-avianex",
  "fa-aviato",
  "fa-award",
  "fa-aws",
  "fa-b",
  "fa-baby",
  "fa-baby-carriage",
  "fa-backward",
  "fa-backward-fast",
  "fa-backward-step",
  "fa-bacon",
  "fa-bacteria",
  "fa-bacterium",
  "fa-bag-shopping",
  "fa-bahai",
  "fa-baht-sign",
  "fa-ban",
  "fa-ban-smoking",
  "fa-bandage",
  "fa-bandcamp",
  "fa-bangladeshi-taka-sign",
  "fa-barcode",
  "fa-bars",
  "fa-bars-progress",
  "fa-bars-staggered",
  "fa-baseball",
  "fa-baseball-bat-ball",
  "fa-basket-shopping",
  "fa-basketball",
  "fa-bath",
  "fa-battery-empty",
  "fa-battery-full",
  "fa-battery-half",
  "fa-battery-quarter",
  "fa-battery-three-quarters",
  "fa-battle-net",
  "fa-bed",
  "fa-bed-pulse",
  "fa-beer-mug-empty",
  "fa-behance",
  "fa-bell",
  "fa-bell-concierge",
  "fa-bell-slash",
  "fa-bezier-curve",
  "fa-bicycle",
  "fa-bilibili",
  "fa-bimobject",
  "fa-binoculars",
  "fa-biohazard",
  "fa-bitbucket",
  "fa-bitcoin",
  "fa-bitcoin-sign",
  "fa-bity",
  "fa-black-tie",
  "fa-blackberry",
  "fa-blender",
  "fa-blender-phone",
  "fa-blog",
  "fa-blogger",
  "fa-blogger-b",
  "fa-bluesky",
  "fa-bluetooth",
  "fa-bluetooth-b",
  "fa-bold",
  "fa-bolt",
  "fa-bolt-lightning",
  "fa-bomb",
  "fa-bone",
  "fa-bong",
  "fa-book",
  "fa-book-atlas",
  "fa-book-bible",
  "fa-book-bookmark",
  "fa-book-journal-whills",
  "fa-book-medical",
  "fa-book-open",
  "fa-book-open-reader",
  "fa-book-quran",
  "fa-book-skull",
  "fa-book-tanakh",
  "fa-bookmark",
  "fa-bootstrap",
  "fa-border-all",
  "fa-border-none",
  "fa-border-top-left",
  "fa-bore-hole",
  "fa-bots",
  "fa-bottle-droplet",
  "fa-bottle-water",
  "fa-bowl-food",
  "fa-bowl-rice",
  "fa-bowling-ball",
  "fa-box",
  "fa-box-archive",
  "fa-box-open",
  "fa-box-tissue",
  "fa-boxes-packing",
  "fa-boxes-stacked",
  "fa-braille",
  "fa-brain",
  "fa-brave",
  "fa-brave-reverse",
  "fa-brazilian-real-sign",
  "fa-bread-slice",
  "fa-bridge",
  "fa-bridge-circle-check",
  "fa-bridge-circle-exclamation",
  "fa-bridge-circle-xmark",
  "fa-bridge-lock",
  "fa-bridge-water",
  "fa-briefcase",
  "fa-briefcase-medical",
  "fa-broom",
  "fa-broom-ball",
  "fa-brush",
  "fa-btc",
  "fa-bucket",
  "fa-buffer",
  "fa-bug",
  "fa-bug-slash",
  "fa-bugs",
  "fa-building",
  "fa-building-circle-arrow-right",
  "fa-building-circle-check",
  "fa-building-circle-exclamation",
  "fa-building-circle-xmark",
  "fa-building-columns",
  "fa-building-flag",
  "fa-building-lock",
  "fa-building-ngo",
  "fa-building-shield",
  "fa-building-un",
  "fa-building-user",
  "fa-building-wheat",
  "fa-bullhorn",
  "fa-bullseye",
  "fa-burger",
  "fa-buromobelexperte",
  "fa-burst",
  "fa-bus",
  "fa-bus-simple",
  "fa-business-time",
  "fa-buy-n-large",
  "fa-buysellads",
  "fa-c",
  "fa-cable-car",
  "fa-cake-candles",
  "fa-calculator",
  "fa-calendar",
  "fa-calendar-check",
  "fa-calendar-day",
  "fa-calendar-days",
  "fa-calendar-minus",
  "fa-calendar-plus",
  "fa-calendar-week",
  "fa-calendar-xmark",
  "fa-camera",
  "fa-camera-retro",
  "fa-camera-rotate",
  "fa-campground",
  "fa-canadian-maple-leaf",
  "fa-candy-cane",
  "fa-cannabis",
  "fa-capsules",
  "fa-car",
  "fa-car-battery",
  "fa-car-burst",
  "fa-car-on",
  "fa-car-rear",
  "fa-car-side",
  "fa-car-tunnel",
  "fa-caravan",
  "fa-caret-down",
  "fa-caret-left",
  "fa-caret-right",
  "fa-caret-up",
  "fa-carrot",
  "fa-cart-arrow-down",
  "fa-cart-flatbed",
  "fa-cart-flatbed-suitcase",
  "fa-cart-plus",
  "fa-cart-shopping",
  "fa-cash-register",
  "fa-cat",
  "fa-cc-amazon-pay",
  "fa-cc-amex",
  "fa-cc-apple-pay",
  "fa-cc-diners-club",
  "fa-cc-discover",
  "fa-cc-jcb",
  "fa-cc-mastercard",
  "fa-cc-paypal",
  "fa-cc-stripe",
  "fa-cc-visa",
  "fa-cedi-sign",
  "fa-cent-sign",
  "fa-centercode",
  "fa-centos",
  "fa-certificate",
  "fa-chair",
  "fa-chalkboard",
  "fa-chalkboard-user",
  "fa-champagne-glasses",
  "fa-charging-station",
  "fa-chart-area",
  "fa-chart-bar",
  "fa-chart-column",
  "fa-chart-diagram",
  "fa-chart-gantt",
  "fa-chart-line",
  "fa-chart-pie",
  "fa-chart-simple",
  "fa-check",
  "fa-check-double",
  "fa-check-to-slot",
  "fa-cheese",
  "fa-chess",
  "fa-chess-bishop",
  "fa-chess-board",
  "fa-chess-king",
  "fa-chess-knight",
  "fa-chess-pawn",
  "fa-chess-queen",
  "fa-chess-rook",
  "fa-chevron-down",
  "fa-chevron-left",
  "fa-chevron-right",
  "fa-chevron-up",
  "fa-child",
  "fa-child-combatant",
  "fa-child-dress",
  "fa-child-reaching",
  "fa-children",
  "fa-chrome",
  "fa-chromecast",
  "fa-church",
  "fa-circle",
  "fa-circle-arrow-down",
  "fa-circle-arrow-left",
  "fa-circle-arrow-right",
  "fa-circle-arrow-up",
  "fa-circle-check",
  "fa-circle-chevron-down",
  "fa-circle-chevron-left",
  "fa-circle-chevron-right",
  "fa-circle-chevron-up",
  "fa-circle-dollar-to-slot",
  "fa-circle-dot",
  "fa-circle-down",
  "fa-circle-exclamation",
  "fa-circle-h",
  "fa-circle-half-stroke",
  "fa-circle-info",
  "fa-circle-left",
  "fa-circle-minus",
  "fa-circle-nodes",
  "fa-circle-notch",
  "fa-circle-pause",
  "fa-circle-play",
  "fa-circle-plus",
  "fa-circle-question",
  "fa-circle-radiation",
  "fa-circle-right",
  "fa-circle-stop",
  "fa-circle-up",
  "fa-circle-user",
  "fa-circle-xmark",
  "fa-city",
  "fa-clapperboard",
  "fa-clipboard",
  "fa-clipboard-check",
  "fa-clipboard-list",
  "fa-clipboard-question",
  "fa-clipboard-user",
  "fa-clock",
  "fa-clock-rotate-left",
  "fa-clone",
  "fa-closed-captioning",
  "fa-cloud",
  "fa-cloud-arrow-down",
  "fa-cloud-arrow-up",
  "fa-cloud-bolt",
  "fa-cloud-meatball",
  "fa-cloud-moon",
  "fa-cloud-moon-rain",
  "fa-cloud-rain",
  "fa-cloud-showers-heavy",
  "fa-cloud-showers-water",
  "fa-cloud-sun",
  "fa-cloud-sun-rain",
  "fa-cloudflare",
  "fa-cloudscale",
  "fa-cloudsmith",
  "fa-cloudversify",
  "fa-clover",
  "fa-cmplid",
  "fa-code",
  "fa-code-branch",
  "fa-code-commit",
  "fa-code-compare",
  "fa-code-fork",
  "fa-code-merge",
  "fa-code-pull-request",
  "fa-codepen",
  "fa-codiepie",
  "fa-coins",
  "fa-colon-sign",
  "fa-comment",
  "fa-comment-dollar",
  "fa-comment-dots",
  "fa-comment-medical",
  "fa-comment-nodes",
  "fa-comment-slash",
  "fa-comment-sms",
  "fa-comments",
  "fa-comments-dollar",
  "fa-compact-disc",
  "fa-compass",
  "fa-compass-drafting",
  "fa-compress",
  "fa-computer",
  "fa-computer-mouse",
  "fa-confluence",
  "fa-connectdevelop",
  "fa-contao",
  "fa-cookie",
  "fa-cookie-bite",
  "fa-copy",
  "fa-copyright",
  "fa-cotton-bureau",
  "fa-couch",
  "fa-cow",
  "fa-cpanel",
  "fa-creative-commons",
  "fa-creative-commons-by",
  "fa-creative-commons-nc",
  "fa-creative-commons-nc-eu",
  "fa-creative-commons-nc-jp",
  "fa-creative-commons-nd",
  "fa-creative-commons-pd",
  "fa-creative-commons-pd-alt",
  "fa-creative-commons-remix",
  "fa-creative-commons-sa",
  "fa-creative-commons-sampling",
  "fa-creative-commons-sampling-plus",
  "fa-creative-commons-share",
  "fa-creative-commons-zero",
  "fa-credit-card",
  "fa-critical-role",
  "fa-crop",
  "fa-crop-simple",
  "fa-cross",
  "fa-crosshairs",
  "fa-crow",
  "fa-crown",
  "fa-crutch",
  "fa-cruzeiro-sign",
  "fa-css",
  "fa-css3",
  "fa-css3-alt",
  "fa-cube",
  "fa-cubes",
  "fa-cubes-stacked",
  "fa-cuttlefish",
  "fa-d",
  "fa-d-and-d",
  "fa-d-and-d-beyond",
  "fa-dailymotion",
  "fa-dart-lang",
  "fa-dashcube",
  "fa-database",
  "fa-debian",
  "fa-deezer",
  "fa-delete-left",
  "fa-delicious",
  "fa-democrat",
  "fa-deploydog",
  "fa-deskpro",
  "fa-desktop",
  "fa-dev",
  "fa-deviantart",
  "fa-dharmachakra",
  "fa-dhl",
  "fa-diagram-next",
  "fa-diagram-predecessor",
  "fa-diagram-project",
  "fa-diagram-successor",
  "fa-diamond",
  "fa-diamond-turn-right",
  "fa-diaspora",
  "fa-dice",
  "fa-dice-d20",
  "fa-dice-d6",
  "fa-dice-five",
  "fa-dice-four",
  "fa-dice-one",
  "fa-dice-six",
  "fa-dice-three",
  "fa-dice-two",
  "fa-digg",
  "fa-digital-ocean",
  "fa-discord",
  "fa-discourse",
  "fa-disease",
  "fa-display",
  "fa-divide",
  "fa-dna",
  "fa-dochub",
  "fa-docker",
  "fa-dog",
  "fa-dollar-sign",
  "fa-dolly",
  "fa-dong-sign",
  "fa-door-closed",
  "fa-door-open",
  "fa-dove",
  "fa-down-left-and-up-right-to-center",
  "fa-down-long",
  "fa-download",
  "fa-draft2digital",
  "fa-dragon",
  "fa-draw-polygon",
  "fa-dribbble",
  "fa-dropbox",
  "fa-droplet",
  "fa-droplet-slash",
  "fa-drum",
  "fa-drum-steelpan",
  "fa-drumstick-bite",
  "fa-drupal",
  "fa-dumbbell",
  "fa-dumpster",
  "fa-dumpster-fire",
  "fa-dungeon",
  "fa-dyalog",
  "fa-e",
  "fa-ear-deaf",
  "fa-ear-listen",
  "fa-earlybirds",
  "fa-earth-africa",
  "fa-earth-americas",
  "fa-earth-asia",
  "fa-earth-europe",
  "fa-earth-oceania",
  "fa-ebay",
  "fa-edge",
  "fa-edge-legacy",
  "fa-egg",
  "fa-eject",
  "fa-elementor",
  "fa-elevator",
  "fa-ellipsis",
  "fa-ellipsis-vertical",
  "fa-ello",
  "fa-ember",
  "fa-empire",
  "fa-envelope",
  "fa-envelope-circle-check",
  "fa-envelope-open",
  "fa-envelope-open-text",
  "fa-envelopes-bulk",
  "fa-envira",
  "fa-equals",
  "fa-eraser",
  "fa-erlang",
  "fa-ethereum",
  "fa-ethernet",
  "fa-etsy",
  "fa-euro-sign",
  "fa-evernote",
  "fa-exclamation",
  "fa-expand",
  "fa-expeditedssl",
  "fa-explosion",
  "fa-eye",
  "fa-eye-dropper",
  "fa-eye-low-vision",
  "fa-eye-slash",
  "fa-f",
  "fa-face-angry",
  "fa-face-dizzy",
  "fa-face-flushed",
  "fa-face-frown",
  "fa-face-frown-open",
  "fa-face-grimace",
  "fa-face-grin",
  "fa-face-grin-beam",
  "fa-face-grin-beam-sweat",
  "fa-face-grin-hearts",
  "fa-face-grin-squint",
  "fa-face-grin-squint-tears",
  "fa-face-grin-stars",
  "fa-face-grin-tears",
  "fa-face-grin-tongue",
  "fa-face-grin-tongue-squint",
  "fa-face-grin-tongue-wink",
  "fa-face-grin-wide",
  "fa-face-grin-wink",
  "fa-face-kiss",
  "fa-face-kiss-beam",
  "fa-face-kiss-wink-heart",
  "fa-face-laugh",
  "fa-face-laugh-beam",
  "fa-face-laugh-squint",
  "fa-face-laugh-wink",
  "fa-face-meh",
  "fa-face-meh-blank",
  "fa-face-rolling-eyes",
  "fa-face-sad-cry",
  "fa-face-sad-tear",
  "fa-face-smile",
  "fa-face-smile-beam",
  "fa-face-smile-wink",
  "fa-face-surprise",
  "fa-face-tired",
  "fa-facebook",
  "fa-facebook-f",
  "fa-facebook-messenger",
  "fa-fan",
  "fa-fantasy-flight-games",
  "fa-faucet",
  "fa-faucet-drip",
  "fa-fax",
  "fa-feather",
  "fa-feather-pointed",
  "fa-fedex",
  "fa-fedora",
  "fa-ferry",
  "fa-figma",
  "fa-file",
  "fa-file-arrow-down",
  "fa-file-arrow-up",
  "fa-file-audio",
  "fa-file-circle-check",
  "fa-file-circle-exclamation",
  "fa-file-circle-minus",
  "fa-file-circle-plus",
  "fa-file-circle-question",
  "fa-file-circle-xmark",
  "fa-file-code",
  "fa-file-contract",
  "fa-file-csv",
  "fa-file-excel",
  "fa-file-export",
  "fa-file-fragment",
  "fa-file-half-dashed",
  "fa-file-image",
  "fa-file-import",
  "fa-file-invoice",
  "fa-file-invoice-dollar",
  "fa-file-lines",
  "fa-file-medical",
  "fa-file-pdf",
  "fa-file-pen",
  "fa-file-powerpoint",
  "fa-file-prescription",
  "fa-file-shield",
  "fa-file-signature",
  "fa-file-video",
  "fa-file-waveform",
  "fa-file-word",
  "fa-file-zipper",
  "fa-files-pinwheel",
  "fa-fill",
  "fa-fill-drip",
  "fa-film",
  "fa-filter",
  "fa-filter-circle-dollar",
  "fa-filter-circle-xmark",
  "fa-fingerprint",
  "fa-fire",
  "fa-fire-burner",
  "fa-fire-extinguisher",
  "fa-fire-flame-curved",
  "fa-fire-flame-simple",
  "fa-firefox",
  "fa-firefox-browser",
  "fa-first-order",
  "fa-first-order-alt",
  "fa-firstdraft",
  "fa-fish",
  "fa-fish-fins",
  "fa-flag",
  "fa-flag-checkered",
  "fa-flag-usa",
  "fa-flask",
  "fa-flask-vial",
  "fa-flickr",
  "fa-flipboard",
  "fa-floppy-disk",
  "fa-florin-sign",
  "fa-flutter",
  "fa-fly",
  "fa-folder",
  "fa-folder-closed",
  "fa-folder-minus",
  "fa-folder-open",
  "fa-folder-plus",
  "fa-folder-tree",
  "fa-font",
  "fa-font-awesome",
  "fa-fonticons",
  "fa-fonticons-fi",
  "fa-football",
  "fa-fort-awesome",
  "fa-fort-awesome-alt",
  "fa-forumbee",
  "fa-forward",
  "fa-forward-fast",
  "fa-forward-step",
  "fa-foursquare",
  "fa-franc-sign",
  "fa-free-code-camp",
  "fa-freebsd",
  "fa-frog",
  "fa-fulcrum",
  "fa-futbol",
  "fa-g",
  "fa-galactic-republic",
  "fa-galactic-senate",
  "fa-gamepad",
  "fa-gas-pump",
  "fa-gauge",
  "fa-gauge-high",
  "fa-gauge-simple",
  "fa-gauge-simple-high",
  "fa-gavel",
  "fa-gear",
  "fa-gears",
  "fa-gem",
  "fa-genderless",
  "fa-get-pocket",
  "fa-gg",
  "fa-gg-circle",
  "fa-ghost",
  "fa-gift",
  "fa-gifts",
  "fa-git",
  "fa-git-alt",
  "fa-github",
  "fa-github-alt",
  "fa-gitkraken",
  "fa-gitlab",
  "fa-gitter",
  "fa-glass-water",
  "fa-glass-water-droplet",
  "fa-glasses",
  "fa-glide",
  "fa-glide-g",
  "fa-globe",
  "fa-gofore",
  "fa-golang",
  "fa-golf-ball-tee",
  "fa-goodreads",
  "fa-goodreads-g",
  "fa-google",
  "fa-google-drive",
  "fa-google-pay",
  "fa-google-play",
  "fa-google-plus",
  "fa-google-plus-g",
  "fa-google-scholar",
  "fa-google-wallet",
  "fa-gopuram",
  "fa-graduation-cap",
  "fa-gratipay",
  "fa-grav",
  "fa-greater-than",
  "fa-greater-than-equal",
  "fa-grip",
  "fa-grip-lines",
  "fa-grip-lines-vertical",
  "fa-grip-vertical",
  "fa-gripfire",
  "fa-group-arrows-rotate",
  "fa-grunt",
  "fa-guarani-sign",
  "fa-guilded",
  "fa-guitar",
  "fa-gulp",
  "fa-gun",
  "fa-h",
  "fa-hacker-news",
  "fa-hackerrank",
  "fa-hammer",
  "fa-hamsa",
  "fa-hand",
  "fa-hand-back-fist",
  "fa-hand-dots",
  "fa-hand-fist",
  "fa-hand-holding",
  "fa-hand-holding-dollar",
  "fa-hand-holding-droplet",
  "fa-hand-holding-hand",
  "fa-hand-holding-heart",
  "fa-hand-holding-medical",
  "fa-hand-lizard",
  "fa-hand-middle-finger",
  "fa-hand-peace",
  "fa-hand-point-down",
  "fa-hand-point-left",
  "fa-hand-point-right",
  "fa-hand-point-up",
  "fa-hand-pointer",
  "fa-hand-scissors",
  "fa-hand-sparkles",
  "fa-hand-spock",
  "fa-handcuffs",
  "fa-hands",
  "fa-hands-asl-interpreting",
  "fa-hands-bound",
  "fa-hands-bubbles",
  "fa-hands-clapping",
  "fa-hands-holding",
  "fa-hands-holding-child",
  "fa-hands-holding-circle",
  "fa-hands-praying",
  "fa-handshake",
  "fa-handshake-angle",
  "fa-handshake-simple",
  "fa-handshake-simple-slash",
  "fa-handshake-slash",
  "fa-hanukiah",
  "fa-hard-drive",
  "fa-hashnode",
  "fa-hashtag",
  "fa-hat-cowboy",
  "fa-hat-cowboy-side",
  "fa-hat-wizard",
  "fa-head-side-cough",
  "fa-head-side-cough-slash",
  "fa-head-side-mask",
  "fa-head-side-virus",
  "fa-heading",
  "fa-headphones",
  "fa-headphones-simple",
  "fa-headset",
  "fa-heart",
  "fa-heart-circle-bolt",
  "fa-heart-circle-check",
  "fa-heart-circle-exclamation",
  "fa-heart-circle-minus",
  "fa-heart-circle-plus",
  "fa-heart-circle-xmark",
  "fa-heart-crack",
  "fa-heart-pulse",
  "fa-helicopter",
  "fa-helicopter-symbol",
  "fa-helmet-safety",
  "fa-helmet-un",
  "fa-hexagon-nodes",
  "fa-hexagon-nodes-bolt",
  "fa-highlighter",
  "fa-hill-avalanche",
  "fa-hill-rockslide",
  "fa-hippo",
  "fa-hips",
  "fa-hire-a-helper",
  "fa-hive",
  "fa-hockey-puck",
  "fa-holly-berry",
  "fa-hooli",
  "fa-hornbill",
  "fa-horse",
  "fa-horse-head",
  "fa-hospital",
  "fa-hospital-user",
  "fa-hot-tub-person",
  "fa-hotdog",
  "fa-hotel",
  "fa-hotjar",
  "fa-hourglass",
  "fa-hourglass-end",
  "fa-hourglass-half",
  "fa-hourglass-start",
  "fa-house",
  "fa-house-chimney",
  "fa-house-chimney-crack",
  "fa-house-chimney-medical",
  "fa-house-chimney-user",
  "fa-house-chimney-window",
  "fa-house-circle-check",
  "fa-house-circle-exclamation",
  "fa-house-circle-xmark",
  "fa-house-crack",
  "fa-house-fire",
  "fa-house-flag",
  "fa-house-flood-water",
  "fa-house-flood-water-circle-arrow-right",
  "fa-house-laptop",
  "fa-house-lock",
  "fa-house-medical",
  "fa-house-medical-circle-check",
  "fa-house-medical-circle-exclamation",
  "fa-house-medical-circle-xmark",
  "fa-house-medical-flag",
  "fa-house-signal",
  "fa-house-tsunami",
  "fa-house-user",
  "fa-houzz",
  "fa-hryvnia-sign",
  "fa-html5",
  "fa-hubspot",
  "fa-hurricane",
  "fa-i",
  "fa-i-cursor",
  "fa-ice-cream",
  "fa-icicles",
  "fa-icons",
  "fa-id-badge",
  "fa-id-card",
  "fa-id-card-clip",
  "fa-ideal",
  "fa-igloo",
  "fa-image",
  "fa-image-portrait",
  "fa-images",
  "fa-imdb",
  "fa-inbox",
  "fa-indent",
  "fa-indian-rupee-sign",
  "fa-industry",
  "fa-infinity",
  "fa-info",
  "fa-instagram",
  "fa-instalod",
  "fa-intercom",
  "fa-internet-explorer",
  "fa-invision",
  "fa-ioxhost",
  "fa-italic",
  "fa-itch-io",
  "fa-itunes",
  "fa-itunes-note",
  "fa-j",
  "fa-jar",
  "fa-jar-wheat",
  "fa-java",
  "fa-jedi",
  "fa-jedi-order",
  "fa-jenkins",
  "fa-jet-fighter",
  "fa-jet-fighter-up",
  "fa-jira",
  "fa-joget",
  "fa-joint",
  "fa-joomla",
  "fa-js",
  "fa-jsfiddle",
  "fa-jug-detergent",
  "fa-jxl",
  "fa-k",
  "fa-kaaba",
  "fa-kaggle",
  "fa-key",
  "fa-keybase",
  "fa-keyboard",
  "fa-keycdn",
  "fa-khanda",
  "fa-kickstarter",
  "fa-kickstarter-k",
  "fa-kip-sign",
  "fa-kit-medical",
  "fa-kitchen-set",
  "fa-kiwi-bird",
  "fa-korvue",
  "fa-l",
  "fa-land-mine-on",
  "fa-landmark",
  "fa-landmark-dome",
  "fa-landmark-flag",
  "fa-language",
  "fa-laptop",
  "fa-laptop-code",
  "fa-laptop-file",
  "fa-laptop-medical",
  "fa-laravel",
  "fa-lari-sign",
  "fa-lastfm",
  "fa-layer-group",
  "fa-leaf",
  "fa-leanpub",
  "fa-left-long",
  "fa-left-right",
  "fa-lemon",
  "fa-less",
  "fa-less-than",
  "fa-less-than-equal",
  "fa-letterboxd",
  "fa-life-ring",
  "fa-lightbulb",
  "fa-line",
  "fa-lines-leaning",
  "fa-link",
  "fa-link-slash",
  "fa-linkedin",
  "fa-linkedin-in",
  "fa-linode",
  "fa-linux",
  "fa-lira-sign",
  "fa-list",
  "fa-list-check",
  "fa-list-ol",
  "fa-list-ul",
  "fa-litecoin-sign",
  "fa-location-arrow",
  "fa-location-crosshairs",
  "fa-location-dot",
  "fa-location-pin",
  "fa-location-pin-lock",
  "fa-lock",
  "fa-lock-open",
  "fa-locust",
  "fa-lungs",
  "fa-lungs-virus",
  "fa-lyft",
  "fa-m",
  "fa-magento",
  "fa-magnet",
  "fa-magnifying-glass",
  "fa-magnifying-glass-arrow-right",
  "fa-magnifying-glass-chart",
  "fa-magnifying-glass-dollar",
  "fa-magnifying-glass-location",
  "fa-magnifying-glass-minus",
  "fa-magnifying-glass-plus",
  "fa-mailchimp",
  "fa-manat-sign",
  "fa-mandalorian",
  "fa-map",
  "fa-map-location",
  "fa-map-location-dot",
  "fa-map-pin",
  "fa-markdown",
  "fa-marker",
  "fa-mars",
  "fa-mars-and-venus",
  "fa-mars-and-venus-burst",
  "fa-mars-double",
  "fa-mars-stroke",
  "fa-mars-stroke-right",
  "fa-mars-stroke-up",
  "fa-martini-glass",
  "fa-martini-glass-citrus",
  "fa-martini-glass-empty",
  "fa-mask",
  "fa-mask-face",
  "fa-mask-ventilator",
  "fa-masks-theater",
  "fa-mastodon",
  "fa-mattress-pillow",
  "fa-maxcdn",
  "fa-maximize",
  "fa-mdb",
  "fa-medal",
  "fa-medapps",
  "fa-medium",
  "fa-medrt",
  "fa-meetup",
  "fa-megaport",
  "fa-memory",
  "fa-mendeley",
  "fa-menorah",
  "fa-mercury",
  "fa-message",
  "fa-meta",
  "fa-meteor",
  "fa-microblog",
  "fa-microchip",
  "fa-microphone",
  "fa-microphone-lines",
  "fa-microphone-lines-slash",
  "fa-microphone-slash",
  "fa-microscope",
  "fa-microsoft",
  "fa-mill-sign",
  "fa-minimize",
  "fa-mintbit",
  "fa-minus",
  "fa-mitten",
  "fa-mix",
  "fa-mixcloud",
  "fa-mixer",
  "fa-mizuni",
  "fa-mobile",
  "fa-mobile-button",
  "fa-mobile-retro",
  "fa-mobile-screen",
  "fa-mobile-screen-button",
  "fa-modx",
  "fa-monero",
  "fa-money-bill",
  "fa-money-bill-1",
  "fa-money-bill-1-wave",
  "fa-money-bill-transfer",
  "fa-money-bill-trend-up",
  "fa-money-bill-wave",
  "fa-money-bill-wheat",
  "fa-money-bills",
  "fa-money-check",
  "fa-money-check-dollar",
  "fa-monument",
  "fa-moon",
  "fa-mortar-pestle",
  "fa-mosque",
  "fa-mosquito",
  "fa-mosquito-net",
  "fa-motorcycle",
  "fa-mound",
  "fa-mountain",
  "fa-mountain-city",
  "fa-mountain-sun",
  "fa-mug-hot",
  "fa-mug-saucer",
  "fa-music",
  "fa-n",
  "fa-naira-sign",
  "fa-napster",
  "fa-neos",
  "fa-network-wired",
  "fa-neuter",
  "fa-newspaper",
  "fa-nfc-directional",
  "fa-nfc-symbol",
  "fa-nimblr",
  "fa-node",
  "fa-node-js",
  "fa-not-equal",
  "fa-notdef",
  "fa-note-sticky",
  "fa-notes-medical",
  "fa-npm",
  "fa-ns8",
  "fa-nutritionix",
  "fa-o",
  "fa-object-group",
  "fa-object-ungroup",
  "fa-octopus-deploy",
  "fa-odnoklassniki",
  "fa-odysee",
  "fa-oil-can",
  "fa-oil-well",
  "fa-old-republic",
  "fa-om",
  "fa-opencart",
  "fa-openid",
  "fa-opensuse",
  "fa-opera",
  "fa-optin-monster",
  "fa-orcid",
  "fa-osi",
  "fa-otter",
  "fa-outdent",
  "fa-p",
  "fa-padlet",
  "fa-page4",
  "fa-pagelines",
  "fa-pager",
  "fa-paint-roller",
  "fa-paintbrush",
  "fa-palette",
  "fa-palfed",
  "fa-pallet",
  "fa-panorama",
  "fa-paper-plane",
  "fa-paperclip",
  "fa-parachute-box",
  "fa-paragraph",
  "fa-passport",
  "fa-paste",
  "fa-patreon",
  "fa-pause",
  "fa-paw",
  "fa-paypal",
  "fa-peace",
  "fa-pen",
  "fa-pen-clip",
  "fa-pen-fancy",
  "fa-pen-nib",
  "fa-pen-ruler",
  "fa-pen-to-square",
  "fa-pencil",
  "fa-people-arrows",
  "fa-people-carry-box",
  "fa-people-group",
  "fa-people-line",
  "fa-people-pulling",
  "fa-people-robbery",
  "fa-people-roof",
  "fa-pepper-hot",
  "fa-perbyte",
  "fa-percent",
  "fa-periscope",
  "fa-person",
  "fa-person-arrow-down-to-line",
  "fa-person-arrow-up-from-line",
  "fa-person-biking",
  "fa-person-booth",
  "fa-person-breastfeeding",
  "fa-person-burst",
  "fa-person-cane",
  "fa-person-chalkboard",
  "fa-person-circle-check",
  "fa-person-circle-exclamation",
  "fa-person-circle-minus",
  "fa-person-circle-plus",
  "fa-person-circle-question",
  "fa-person-circle-xmark",
  "fa-person-digging",
  "fa-person-dots-from-line",
  "fa-person-dress",
  "fa-person-dress-burst",
  "fa-person-drowning",
  "fa-person-falling",
  "fa-person-falling-burst",
  "fa-person-half-dress",
  "fa-person-harassing",
  "fa-person-hiking",
  "fa-person-military-pointing",
  "fa-person-military-rifle",
  "fa-person-military-to-person",
  "fa-person-praying",
  "fa-person-pregnant",
  "fa-person-rays",
  "fa-person-rifle",
  "fa-person-running",
  "fa-person-shelter",
  "fa-person-skating",
  "fa-person-skiing",
  "fa-person-skiing-nordic",
  "fa-person-snowboarding",
  "fa-person-swimming",
  "fa-person-through-window",
  "fa-person-walking",
  "fa-person-walking-arrow-loop-left",
  "fa-person-walking-arrow-right",
  "fa-person-walking-dashed-line-arrow-right",
  "fa-person-walking-luggage",
  "fa-person-walking-with-cane",
  "fa-peseta-sign",
  "fa-peso-sign",
  "fa-phabricator",
  "fa-phoenix-framework",
  "fa-phoenix-squadron",
  "fa-phone",
  "fa-phone-flip",
  "fa-phone-slash",
  "fa-phone-volume",
  "fa-photo-film",
  "fa-php",
  "fa-pied-piper",
  "fa-pied-piper-alt",
  "fa-pied-piper-hat",
  "fa-pied-piper-pp",
  "fa-piggy-bank",
  "fa-pills",
  "fa-pinterest",
  "fa-pinterest-p",
  "fa-pix",
  "fa-pixiv",
  "fa-pizza-slice",
  "fa-place-of-worship",
  "fa-plane",
  "fa-plane-arrival",
  "fa-plane-circle-check",
  "fa-plane-circle-exclamation",
  "fa-plane-circle-xmark",
  "fa-plane-departure",
  "fa-plane-lock",
  "fa-plane-slash",
  "fa-plane-up",
  "fa-plant-wilt",
  "fa-plate-wheat",
  "fa-play",
  "fa-playstation",
  "fa-plug",
  "fa-plug-circle-bolt",
  "fa-plug-circle-check",
  "fa-plug-circle-exclamation",
  "fa-plug-circle-minus",
  "fa-plug-circle-plus",
  "fa-plug-circle-xmark",
  "fa-plus",
  "fa-plus-minus",
  "fa-podcast",
  "fa-poo",
  "fa-poo-storm",
  "fa-poop",
  "fa-power-off",
  "fa-prescription",
  "fa-prescription-bottle",
  "fa-prescription-bottle-medical",
  "fa-print",
  "fa-product-hunt",
  "fa-pump-medical",
  "fa-pump-soap",
  "fa-pushed",
  "fa-puzzle-piece",
  "fa-python",
  "fa-q",
  "fa-qq",
  "fa-qrcode",
  "fa-question",
  "fa-quinscape",
  "fa-quora",
  "fa-quote-left",
  "fa-quote-right",
  "fa-r",
  "fa-r-project",
  "fa-radiation",
  "fa-radio",
  "fa-rainbow",
  "fa-ranking-star",
  "fa-raspberry-pi",
  "fa-ravelry",
  "fa-react",
  "fa-reacteurope",
  "fa-readme",
  "fa-rebel",
  "fa-receipt",
  "fa-record-vinyl",
  "fa-rectangle-ad",
  "fa-rectangle-list",
  "fa-rectangle-xmark",
  "fa-recycle",
  "fa-red-river",
  "fa-reddit",
  "fa-reddit-alien",
  "fa-redhat",
  "fa-registered",
  "fa-renren",
  "fa-repeat",
  "fa-reply",
  "fa-reply-all",
  "fa-replyd",
  "fa-republican",
  "fa-researchgate",
  "fa-resolving",
  "fa-restroom",
  "fa-retweet",
  "fa-rev",
  "fa-ribbon",
  "fa-right-from-bracket",
  "fa-right-left",
  "fa-right-long",
  "fa-right-to-bracket",
  "fa-ring",
  "fa-road",
  "fa-road-barrier",
  "fa-road-bridge",
  "fa-road-circle-check",
  "fa-road-circle-exclamation",
  "fa-road-circle-xmark",
  "fa-road-lock",
  "fa-road-spikes",
  "fa-robot",
  "fa-rocket",
  "fa-rocketchat",
  "fa-rockrms",
  "fa-rotate",
  "fa-rotate-left",
  "fa-rotate-right",
  "fa-route",
  "fa-rss",
  "fa-ruble-sign",
  "fa-rug",
  "fa-ruler",
  "fa-ruler-combined",
  "fa-ruler-horizontal",
  "fa-ruler-vertical",
  "fa-rupee-sign",
  "fa-rupiah-sign",
  "fa-rust",
  "fa-s",
  "fa-sack-dollar",
  "fa-sack-xmark",
  "fa-safari",
  "fa-sailboat",
  "fa-salesforce",
  "fa-sass",
  "fa-satellite",
  "fa-satellite-dish",
  "fa-scale-balanced",
  "fa-scale-unbalanced",
  "fa-scale-unbalanced-flip",
  "fa-schlix",
  "fa-school",
  "fa-school-circle-check",
  "fa-school-circle-exclamation",
  "fa-school-circle-xmark",
  "fa-school-flag",
  "fa-school-lock",
  "fa-scissors",
  "fa-screenpal",
  "fa-screwdriver",
  "fa-screwdriver-wrench",
  "fa-scribd",
  "fa-scroll",
  "fa-scroll-torah",
  "fa-sd-card",
  "fa-searchengin",
  "fa-section",
  "fa-seedling",
  "fa-sellcast",
  "fa-sellsy",
  "fa-server",
  "fa-servicestack",
  "fa-shapes",
  "fa-share",
  "fa-share-from-square",
  "fa-share-nodes",
  "fa-sheet-plastic",
  "fa-shekel-sign",
  "fa-shield",
  "fa-shield-cat",
  "fa-shield-dog",
  "fa-shield-halved",
  "fa-shield-heart",
  "fa-shield-virus",
  "fa-ship",
  "fa-shirt",
  "fa-shirtsinbulk",
  "fa-shoe-prints",
  "fa-shoelace",
  "fa-shop",
  "fa-shop-lock",
  "fa-shop-slash",
  "fa-shopify",
  "fa-shopware",
  "fa-shower",
  "fa-shrimp",
  "fa-shuffle",
  "fa-shuttle-space",
  "fa-sign-hanging",
  "fa-signal",
  "fa-signal-messenger",
  "fa-signature",
  "fa-signs-post",
  "fa-sim-card",
  "fa-simplybuilt",
  "fa-sink",
  "fa-sistrix",
  "fa-sitemap",
  "fa-sith",
  "fa-sitrox",
  "fa-sketch",
  "fa-skull",
  "fa-skull-crossbones",
  "fa-skyatlas",
  "fa-skype",
  "fa-slack",
  "fa-slash",
  "fa-sleigh",
  "fa-sliders",
  "fa-slideshare",
  "fa-smog",
  "fa-smoking",
  "fa-snapchat",
  "fa-snowflake",
  "fa-snowman",
  "fa-snowplow",
  "fa-soap",
  "fa-socks",
  "fa-solar-panel",
  "fa-sort",
  "fa-sort-down",
  "fa-sort-up",
  "fa-soundcloud",
  "fa-sourcetree",
  "fa-spa",
  "fa-space-awesome",
  "fa-spaghetti-monster-flying",
  "fa-speakap",
  "fa-speaker-deck",
  "fa-spell-check",
  "fa-spider",
  "fa-spinner",
  "fa-splotch",
  "fa-spoon",
  "fa-spotify",
  "fa-spray-can",
  "fa-spray-can-sparkles",
  "fa-square",
  "fa-square-arrow-up-right",
  "fa-square-behance",
  "fa-square-binary",
  "fa-square-bluesky",
  "fa-square-caret-down",
  "fa-square-caret-left",
  "fa-square-caret-right",
  "fa-square-caret-up",
  "fa-square-check",
  "fa-square-dribbble",
  "fa-square-envelope",
  "fa-square-facebook",
  "fa-square-font-awesome",
  "fa-square-font-awesome-stroke",
  "fa-square-full",
  "fa-square-git",
  "fa-square-github",
  "fa-square-gitlab",
  "fa-square-google-plus",
  "fa-square-h",
  "fa-square-hacker-news",
  "fa-square-instagram",
  "fa-square-js",
  "fa-square-lastfm",
  "fa-square-letterboxd",
  "fa-square-minus",
  "fa-square-nfi",
  "fa-square-odnoklassniki",
  "fa-square-parking",
  "fa-square-pen",
  "fa-square-person-confined",
  "fa-square-phone",
  "fa-square-phone-flip",
  "fa-square-pied-piper",
  "fa-square-pinterest",
  "fa-square-plus",
  "fa-square-poll-horizontal",
  "fa-square-poll-vertical",
  "fa-square-reddit",
  "fa-square-root-variable",
  "fa-square-rss",
  "fa-square-share-nodes",
  "fa-square-snapchat",
  "fa-square-steam",
  "fa-square-threads",
  "fa-square-tumblr",
  "fa-square-twitter",
  "fa-square-up-right",
  "fa-square-upwork",
  "fa-square-viadeo",
  "fa-square-vimeo",
  "fa-square-virus",
  "fa-square-web-awesome",
  "fa-square-web-awesome-stroke",
  "fa-square-whatsapp",
  "fa-square-x-twitter",
  "fa-square-xing",
  "fa-square-xmark",
  "fa-square-youtube",
  "fa-squarespace",
  "fa-stack-exchange",
  "fa-stack-overflow",
  "fa-stackpath",
  "fa-staff-snake",
  "fa-stairs",
  "fa-stamp",
  "fa-stapler",
  "fa-star",
  "fa-star-and-crescent",
  "fa-star-half",
  "fa-star-half-stroke",
  "fa-star-of-david",
  "fa-star-of-life",
  "fa-staylinked",
  "fa-steam",
  "fa-steam-symbol",
  "fa-sterling-sign",
  "fa-stethoscope",
  "fa-sticker-mule",
  "fa-stop",
  "fa-stopwatch",
  "fa-stopwatch-20",
  "fa-store",
  "fa-store-slash",
  "fa-strava",
  "fa-street-view",
  "fa-strikethrough",
  "fa-stripe",
  "fa-stripe-s",
  "fa-stroopwafel",
  "fa-stubber",
  "fa-studiovinari",
  "fa-stumbleupon",
  "fa-stumbleupon-circle",
  "fa-subscript",
  "fa-suitcase",
  "fa-suitcase-medical",
  "fa-suitcase-rolling",
  "fa-sun",
  "fa-sun-plant-wilt",
  "fa-superpowers",
  "fa-superscript",
  "fa-supple",
  "fa-suse",
  "fa-swatchbook",
  "fa-swift",
  "fa-symfony",
  "fa-synagogue",
  "fa-syringe",
  "fa-t",
  "fa-table",
  "fa-table-cells",
  "fa-table-cells-column-lock",
  "fa-table-cells-large",
  "fa-table-cells-row-lock",
  "fa-table-cells-row-unlock",
  "fa-table-columns",
  "fa-table-list",
  "fa-table-tennis-paddle-ball",
  "fa-tablet",
  "fa-tablet-button",
  "fa-tablet-screen-button",
  "fa-tablets",
  "fa-tachograph-digital",
  "fa-tag",
  "fa-tags",
  "fa-tape",
  "fa-tarp",
  "fa-tarp-droplet",
  "fa-taxi",
  "fa-teamspeak",
  "fa-teeth",
  "fa-teeth-open",
  "fa-telegram",
  "fa-temperature-arrow-down",
  "fa-temperature-arrow-up",
  "fa-temperature-empty",
  "fa-temperature-full",
  "fa-temperature-half",
  "fa-temperature-high",
  "fa-temperature-low",
  "fa-temperature-quarter",
  "fa-temperature-three-quarters",
  "fa-tencent-weibo",
  "fa-tenge-sign",
  "fa-tent",
  "fa-tent-arrow-down-to-line",
  "fa-tent-arrow-left-right",
  "fa-tent-arrow-turn-left",
  "fa-tent-arrows-down",
  "fa-tents",
  "fa-terminal",
  "fa-text-height",
  "fa-text-slash",
  "fa-text-width",
  "fa-the-red-yeti",
  "fa-themeco",
  "fa-themeisle",
  "fa-thermometer",
  "fa-think-peaks",
  "fa-threads",
  "fa-thumbs-down",
  "fa-thumbs-up",
  "fa-thumbtack",
  "fa-thumbtack-slash",
  "fa-ticket",
  "fa-ticket-simple",
  "fa-tiktok",
  "fa-timeline",
  "fa-toggle-off",
  "fa-toggle-on",
  "fa-toilet",
  "fa-toilet-paper",
  "fa-toilet-paper-slash",
  "fa-toilet-portable",
  "fa-toilets-portable",
  "fa-toolbox",
  "fa-tooth",
  "fa-torii-gate",
  "fa-tornado",
  "fa-tower-broadcast",
  "fa-tower-cell",
  "fa-tower-observation",
  "fa-tractor",
  "fa-trade-federation",
  "fa-trademark",
  "fa-traffic-light",
  "fa-trailer",
  "fa-train",
  "fa-train-subway",
  "fa-train-tram",
  "fa-transgender",
  "fa-trash",
  "fa-trash-arrow-up",
  "fa-trash-can",
  "fa-trash-can-arrow-up",
  "fa-tree",
  "fa-tree-city",
  "fa-trello",
  "fa-triangle-exclamation",
  "fa-trophy",
  "fa-trowel",
  "fa-trowel-bricks",
  "fa-truck",
  "fa-truck-arrow-right",
  "fa-truck-droplet",
  "fa-truck-fast",
  "fa-truck-field",
  "fa-truck-field-un",
  "fa-truck-front",
  "fa-truck-medical",
  "fa-truck-monster",
  "fa-truck-moving",
  "fa-truck-pickup",
  "fa-truck-plane",
  "fa-truck-ramp-box",
  "fa-tty",
  "fa-tumblr",
  "fa-turkish-lira-sign",
  "fa-turn-down",
  "fa-turn-up",
  "fa-tv",
  "fa-twitch",
  "fa-twitter",
  "fa-typo3",
  "fa-u",
  "fa-uber",
  "fa-ubuntu",
  "fa-uikit",
  "fa-umbraco",
  "fa-umbrella",
  "fa-umbrella-beach",
  "fa-uncharted",
  "fa-underline",
  "fa-uniregistry",
  "fa-unity",
  "fa-universal-access",
  "fa-unlock",
  "fa-unlock-keyhole",
  "fa-unsplash",
  "fa-untappd",
  "fa-up-down",
  "fa-up-down-left-right",
  "fa-up-long",
  "fa-up-right-and-down-left-from-center",
  "fa-up-right-from-square",
  "fa-upload",
  "fa-ups",
  "fa-upwork",
  "fa-usb",
  "fa-user",
  "fa-user-astronaut",
  "fa-user-check",
  "fa-user-clock",
  "fa-user-doctor",
  "fa-user-gear",
  "fa-user-graduate",
  "fa-user-group",
  "fa-user-injured",
  "fa-user-large",
  "fa-user-large-slash",
  "fa-user-lock",
  "fa-user-minus",
  "fa-user-ninja",
  "fa-user-nurse",
  "fa-user-pen",
  "fa-user-plus",
  "fa-user-secret",
  "fa-user-shield",
  "fa-user-slash",
  "fa-user-tag",
  "fa-user-tie",
  "fa-user-xmark",
  "fa-users",
  "fa-users-between-lines",
  "fa-users-gear",
  "fa-users-line",
  "fa-users-rays",
  "fa-users-rectangle",
  "fa-users-slash",
  "fa-users-viewfinder",
  "fa-usps",
  "fa-ussunnah",
  "fa-utensils",
  "fa-v",
  "fa-vaadin",
  "fa-van-shuttle",
  "fa-vault",
  "fa-vector-square",
  "fa-venus",
  "fa-venus-double",
  "fa-venus-mars",
  "fa-vest",
  "fa-vest-patches",
  "fa-viacoin",
  "fa-viadeo",
  "fa-vial",
  "fa-vial-circle-check",
  "fa-vial-virus",
  "fa-vials",
  "fa-viber",
  "fa-video",
  "fa-video-slash",
  "fa-vihara",
  "fa-vimeo",
  "fa-vimeo-v",
  "fa-vine",
  "fa-virus",
  "fa-virus-covid",
  "fa-virus-covid-slash",
  "fa-virus-slash",
  "fa-viruses",
  "fa-vk",
  "fa-vnv",
  "fa-voicemail",
  "fa-volcano",
  "fa-volleyball",
  "fa-volume-high",
  "fa-volume-low",
  "fa-volume-off",
  "fa-volume-xmark",
  "fa-vr-cardboard",
  "fa-vuejs",
  "fa-w",
  "fa-walkie-talkie",
  "fa-wallet",
  "fa-wand-magic",
  "fa-wand-magic-sparkles",
  "fa-wand-sparkles",
  "fa-warehouse",
  "fa-watchman-monitoring",
  "fa-water",
  "fa-water-ladder",
  "fa-wave-square",
  "fa-waze",
  "fa-web-awesome",
  "fa-webflow",
  "fa-weebly",
  "fa-weibo",
  "fa-weight-hanging",
  "fa-weight-scale",
  "fa-weixin",
  "fa-whatsapp",
  "fa-wheat-awn",
  "fa-wheat-awn-circle-exclamation",
  "fa-wheelchair",
  "fa-wheelchair-move",
  "fa-whiskey-glass",
  "fa-whmcs",
  "fa-wifi",
  "fa-wikipedia-w",
  "fa-wind",
  "fa-window-maximize",
  "fa-window-minimize",
  "fa-window-restore",
  "fa-windows",
  "fa-wine-bottle",
  "fa-wine-glass",
  "fa-wine-glass-empty",
  "fa-wirsindhandwerk",
  "fa-wix",
  "fa-wizards-of-the-coast",
  "fa-wodu",
  "fa-wolf-pack-battalion",
  "fa-won-sign",
  "fa-wordpress",
  "fa-wordpress-simple",
  "fa-worm",
  "fa-wpbeginner",
  "fa-wpexplorer",
  "fa-wpforms",
  "fa-wpressr",
  "fa-wrench",
  "fa-x",
  "fa-x-ray",
  "fa-x-twitter",
  "fa-xbox",
  "fa-xing",
  "fa-xmark",
  "fa-xmarks-lines",
  "fa-y",
  "fa-y-combinator",
  "fa-yahoo",
  "fa-yammer",
  "fa-yandex",
  "fa-yandex-international",
  "fa-yarn",
  "fa-yelp",
  "fa-yen-sign",
  "fa-yin-yang",
  "fa-yoast",
  "fa-youtube",
  "fa-z",
  "fa-zhihu"
]
